/**
 * 微信分享组件
 */

class DYWXShare {
    constructor (config) {
        this.config = Object.assign({
            // 分享配置
            shareSetting: {
                // 标题
                title: '',
                // 描述
                desc: '',
                // 链接
                link: '',
                // 图片
                imgUrl: ''
            },
            // 分享成功回调
            success: null,
            // 取消分享回调
            cancel: null
        }, config);

        this.init();
    }

    // 注册微信配置
    setConfig (configData) {
        window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数。
            appId: configData.appId, // 必填，公众号的唯一标识
            timestamp: configData.timestamp, // 必填，生成签名的时间戳
            nonceStr: configData.nonceStr, // 必填，生成签名的随机串
            signature: configData.signature, // 必填，签名，见附录1
            jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone'
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });

        const { shareSetting, success, cancel } = this.config;

        const setting = {
            title: shareSetting.title,
            desc: shareSetting.desc,
            link: shareSetting.link,
            imgUrl: shareSetting.imgUrl,
            success: () => {
                // 用户确认分享后执行的回调函数
                success && success();
            },
            cancel: () => {
                // 用户取消分享后执行的回调函数
                cancel && cancel();
            }
        };
        window.wx.ready(() => {
            window.wx.onMenuShareTimeline(setting);
            window.wx.onMenuShareAppMessage(setting);
            window.wx.onMenuShareQQ(setting);
            window.wx.onMenuShareWeibo(setting);
            window.wx.onMenuShareQZone(setting);
        });
    }

    // 获取微信配置
    fetchConfig () {
        $.getJSON(
            '/special/wxShare/getSign',
            {
                url: this.config.shareSetting.link
            },
            (data) => {
                this.setConfig(data);
            }
        );
    }

    init () {
        this.fetchConfig();
    }
}

export default DYWXShare;
